<template>
  <b-form @submit.prevent="guardar">
    <b-form-row>
      <b-form-group class="col-md-6">
        <label for="controles_tecnicos">
          Controles técnicos de ingeniería apropiados <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="controles_tecnicos"
                      name="controles_tecnicos"
                      required
                      data-vv-as=" "
                      v-model="selectedSeccion8.controles_tecnicos"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion8.controles_tecnicos')"
        />
      </b-form-group>
      <b-form-group class="col-md-6">
        <label for="medidas_proteccion_individual">
          Medidas de protección individual <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="medidas_proteccion_individual"
                         name="medidas_proteccion_individual"
                         required
                         data-vv-as=" "
                         v-model="selectedSeccion8.medidas_proteccion_individual"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion8.medidas_proteccion_individual')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row class="bg-row-gray">
      <b-form-group class="col-md-6">
        <label for="proteccion_respiratoria">
          Protección respiratoria <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="proteccion_respiratoria"
                         name="proteccion_respiratoria"
                         required
                         data-vv-as=" "
                         v-model="selectedSeccion8.proteccion_respiratoria"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion8.proteccion_respiratoria')"
        />
      </b-form-group>
      <b-form-group class="col-md-6">
        <label for="proteccion_manos">
          Protección en manos <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="proteccion_manos"
                         name="proteccion_manos"
                         data-vv-as=" "
                         v-model="selectedSeccion8.proteccion_manos"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion8.proteccion_manos')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row>
      <b-form-group class="col-md-6">
        <label for="proteccion_ojos">
          Protección de ojos y rostro <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="proteccion_ojos"
                         name="proteccion_ojos"
                         data-vv-as=" "
                         v-model="selectedSeccion8.proteccion_ojos"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion8.proteccion_ojos')"
        />
      </b-form-group>
      <b-form-group class="col-md-6">
        <label for="proteccion_caso_emergencia">
          Protección en caso de emergencia <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="proteccion_caso_emergencia"
                         name="proteccion_caso_emergencia"
                         data-vv-as=" "
                         v-model="selectedSeccion8.proteccion_caso_emergencia"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion8.proteccion_caso_emergencia')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row class="bg-row-gray">
      <b-form-group class="col-md-6">
        <label for="proteccion_corporal">
          Protección corporal <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="proteccion_corporal"
                         name="proteccion_corporal"
                         data-vv-as=" "
                         v-model="selectedSeccion8.proteccion_corporal"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion8.proteccion_corporal')"
        />
      </b-form-group>
      <b-form-group class="col-md-6">
        <label for="consideraciones_higiene">
          Consideraciones generales de higiene <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="consideraciones_higiene"
                         name="consideraciones_higiene"
                         data-vv-as=" "
                         v-model="selectedSeccion8.consideraciones_higiene"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion8.consideraciones_higiene')"
        />
      </b-form-group>
    </b-form-row>
    <b-col md="12" v-if="valores_exposicion.length !== 0" class="text-right">
      <i>Total valores de exposición: {{valores_exposicion.length}}</i>
    </b-col>
    <b-col v-else class="text-right">
      <i>Para añadir valores de exposición haga clic en el botón "TLVs"</i>
    </b-col>

    <!-- Modal CAS -->
    <b-modal id="cas-modal"
             title="Valores de exposición"
             size="lg"
             @show="getValoresExposicion()"
    >
      <ModalValoresExposicion />

      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="primary" v-b-modal="'cas-sugerencias'">
          Ver sugerencias
        </b-button>
        <b-button size="sm" variant="danger" @click="cancel()">
          Cerrar
        </b-button>
      </template>
    </b-modal>

    <!-- Modal EPP -->
    <b-modal id="epps-modal"
             title="Elementos de Protección Personal"
             size="lg"
             @show="showModalElementosProteccion()"
    >
      <ModalElementosProteccion />

      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="primary" @click="guardarEpp()">
          Guardar
        </b-button>
        <b-button size="sm" variant="danger" @click="cancel()">
          Cerrar
        </b-button>
      </template>
    </b-modal>

    <hr>
    <FooterButtons back="/fds/listar" :buttons="footerButtons" />
  </b-form>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import FooterButtons from '../../componentes/FooterButtons';
import ModalValoresExposicion from "./ModalValoresExposicion";
import ModalElementosProteccion from "./ModalElementosProteccion";

export default {
  name: "FDS-Seccion8",
  components: {
    ModalValoresExposicion,
    ModalElementosProteccion,
    FooterButtons
  },
  data() {
    return {
      footerButtons: [
        {
          key: 'btonModalCas',
          variant: 'primary',
          class: 'fa fa-list fa-lg',
          type: 'modal',
          text: 'TLVs',
          ref: 'cas-modal',
        },
        {
          key: 'btonModalEpp',
          variant: 'primary',
          class: 'fa fa-user-circle fa-lg',
          type: 'modal',
          text: 'EPPs',
          ref: 'epps-modal',
        }
      ]
    };
  },
  async created() {
    await this.setSeccionActual(8);
    let id_empresa = await this.obtenerIdEmpresaUsuario();
    await this.setIdEmpresaFdsProducto(id_empresa);
    if (this.$route.params.id_fds_producto !== undefined) {
      let id_fds_producto = this.$route.params.id_fds_producto;
      let data = {
        id_empresa: id_empresa,
        id_fds_producto: id_fds_producto,
      };
      await this.getSeccion(data);
      await this.setIdFdsProductoSeccion(id_fds_producto);
      await this.setTipoPeligro('TLV');
      await this.getValoresExposicion();
    } else {
      await this.resetSeccion();
    }
  },
  methods: {
    async guardar() {
      if (this.accion === 'crear') {
        await this.crearSeccion();
      } else if (this.accion === 'editar'){
        await this.actualizarSeccion();
      }
    },
    async guardarEpp() {
      console.log(this.selectedElementosProteccion);
      if (this.selectedElementosProteccion.accion === 'crear') {
        await this.guardarElementosProteccion();
      } else if (this.selectedElementosProteccion.accion === 'editar') {
        await this.actualizarElementosProteccion();
      }
    },
    async showModalElementosProteccion() {
      await this.getElementosProteccion();
    },
    ...mapMutations('fds_productos', [
      'setSeccionActual',
      'setIdFdsProductoSeccion',
      'setTipoPeligro'
    ]),
    ...mapActions('dashboard', [
      'obtenerIdEmpresaUsuario',
    ]),
    ...mapActions('fds_productos', [
      'getSeccion',
      'crearSeccion',
      'actualizarSeccion',
      'getValoresExposicion',
      'getElementosProteccion',
      'guardarElementosProteccion',
      'actualizarElementosProteccion'
    ]),
    ...mapMutations('fds_productos',[
      'setIdEmpresaFdsProducto',
      'setSeccionActual',
      'resetSeccion',
    ]),
  },
  computed: {
    ...mapState('fds_productos',[
      'id_empresa',
      'accion',
      'selectedSeccion8',
      'valores_exposicion',
      'selectedElementosProteccion',
      'error'
    ])
  }
}
</script>
<style scoped>
.bg-row-gray {
  background-color: #f0f3f5 !important;
  margin-top: 0.5em !important;
  padding-top: 0.5em !important;
  margin-bottom: 0.5em !important;
  padding-bottom: 0.5em !important;
}
</style>
